import moment from 'moment';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { connect } from 'react-redux';
import { showLoadingScreen } from '../../actions/app-actions';
import Modal from '../../common/modal/modal';
import PromoCodeContainer from '../../common/promo-code/promo-code';
import { selectPriceTypeTickets } from '../../filter/actions/filter-actions';
import FilterPageHeader from '../../filter/components/filter-page-header';
import PriceTypeFilterContainer from '../../filter/components/price-type-filter-container';
import { getSelectedTicketCount } from '../../helpers/price-type-helpers';
import { CartHelpers } from '../../helpers/cart-helpers';
import { IAppState } from '../../reducers/index';


export interface IFilterState {
    showMissingTicketsError: boolean;
    invalidTicketsMessage: string;
    lastFocused: any;
    modalFocusableElements: any[];
};

class PackageQuantitySelect extends React.Component<IAppState, IFilterState>{
    static contextTypes = {
        router: PropTypes.object
    }

    constructor(props: IAppState) {
        super(props);
        // If no app settings are passed in, let it through until something comes.

        this.state = {
            showMissingTicketsError: false,
            invalidTicketsMessage: "",
            lastFocused: null,
            modalFocusableElements: null
        };
    }



    get canProceed(): boolean {
        return getSelectedTicketCount(this.props.priceTypesModel) > 0;
    }

    get disableText(): string {
        if (this.canProceed) {
            return "";
        }

        return "disabled";
    }

    componentWillReceiveProps(props: IAppState) {
        // If no app settings are passed in, let it through until something comes.
        let hasNotPassed: boolean;
        if (props.appSettingsModel.performanceDate) {
            const currPerformanceDate = moment(props.appSettingsModel.performanceDate);
            hasNotPassed = currPerformanceDate.diff(moment()) >= 0;
        } else {
            hasNotPassed = true;
        }

        this.setState({
            showMissingTicketsError: this.state.showMissingTicketsError,
            invalidTicketsMessage: this.state.invalidTicketsMessage,
            lastFocused: null,
            modalFocusableElements: null
        });
    }

    render() {

        const { appSettingsModel } = this.props;
        const { isSuperpackageConflictResolutionRequired, itemOnSale, itemAvailable,
            superpackageConflictModalTitle, superpackageConflictModalMessage, superpackageConflictModalConfirmButtonText, superpackageConflictModalRejectButtonText,
            isFlexpackageConflictResolutionRequired, 
            flexPackageConflictModalTitle,
            flexPackageConflictModalMessage,
            flexPackageConflictModalConfirmButtonText,
            flexPackageConflictModalRejectButtonText
        } = appSettingsModel;        

        const itemSoldOut = itemOnSale && !itemAvailable;

        return (
            <>
                <main className="filters-container" id="main-content">
                    <FilterPageHeader
                        title={this.props.appSettingsModel.subscriptionQuantitySelectPageHeaderTitle}
                        message={this.props.appSettingsModel.subscriptionQuantitySelectPageHeaderMessage} />

                    <PromoCodeContainer collapseDown={true} culture={this.props.appSettingsModel.currentCulture} />

                    <PriceTypeFilterContainer
                        priceTypes={this.props.priceTypesModel.priceTypes}
                        onChangePriceTypeQuantity={this._onChangePriceTypeQuantity.bind(this)}
                        appSettingsModel={this.props.appSettingsModel}
                        showComponent={true}
                        multipleOfSeatsRequiredToContinue={CartHelpers.checkForcedMultipleReserve(this.props.appSettingsModel.forcePatronsReserveInMultiples, this.props.priceTypesModel.priceTypes)}
                    />
                </main>

                {
                    !itemOnSale && 
                    <Modal modalKey="performance not on sale" isError={true}
                        title={this.props.appSettingsModel.performanceNotOnSaleModalTitle}
                        message={this.props.appSettingsModel.performanceNotOnSaleModalMessage}
                        confirmFunction={this._performanceNotOnSaleRedirect.bind(this)}
                        confirmString={this.props.appSettingsModel.performanceNotOnSaleRedirectButtonText}
                        closeFunction={this._performanceNotOnSaleRedirect.bind(this)}
                    />
                }

                {
                    itemSoldOut &&
                    <Modal modalKey="performance sold out" isError={true}
                        title={this.props.appSettingsModel.performanceSoldOutModalTitle}
                        message={this.props.appSettingsModel.performanceSoldOutModalMessage}
                        confirmFunction={this._performanceNotOnSaleRedirect.bind(this)}
                        confirmString={this.props.appSettingsModel.performanceNotOnSaleRedirectButtonText}
                        closeFunction={this._performanceNotOnSaleRedirect.bind(this)}
                    />
                }                

                {
                    isSuperpackageConflictResolutionRequired &&
                    <Modal modalKey="superpackage conflict" isError={true}
                        title={superpackageConflictModalTitle}
                        message={superpackageConflictModalMessage}
                        confirmFunction={this._superPackageConflictConfirmRedirect.bind(this)}
                        confirmString={superpackageConflictModalConfirmButtonText}
                        cancelString={superpackageConflictModalRejectButtonText}
                        cancelFunction={this._superPackageConflictRejectRedirect.bind(this)}
                    />
                }

                {
                    (isFlexpackageConflictResolutionRequired) &&  // Temporarily force modal
                    <Modal modalKey="flexpackage conflict" isError={true}
                        title={flexPackageConflictModalTitle}
                        message={flexPackageConflictModalMessage}
                        confirmFunction={this._flexPackageConflictConfirmRedirect.bind(this)}
                        confirmString={flexPackageConflictModalConfirmButtonText}
                        cancelString={flexPackageConflictModalRejectButtonText}
                        cancelFunction={this._flexPackageConflictRejectRedirect.bind(this)}
                    />
                }

                <footer className="footer-wrapper">

                    <div className="footer-container">
                        <button type="button" disabled={this.disableText.length > 0} onClick={() => this._onProceedClick()} className={"footer-link " + this.disableText}><span>{this.props.appSettingsModel.packageQuantityStepOneButton}</span></button>
                    </div>
                </footer>
            </>

        );
    }

    _performanceNotOnSaleRedirect() {
        window.location.href = this.props.appSettingsModel.performanceNotOnSaleRedirectUrl;
    }

    _ticketQuantityZeroRedirect() {
        window.location.href = this.props.appSettingsModel.ticketQuantityZeroRedirectUrl;
    }

    _onProceedClick() {
        this.props.dispatch(showLoadingScreen());
        this.context.router.history.push("/filters");
    }

    _onChangePriceTypeQuantity(quantity: number, priceTypeId: number) {
        this.props.dispatch(selectPriceTypeTickets(priceTypeId, quantity, false, [], true));
    }

    _superPackageConflictConfirmRedirect() {
        if (!this.props.appSettingsModel.superpackageConflictConfirmRedirectUrlQueryString) return;

        this.props.dispatch(showLoadingScreen());

        const url = new URL(window.location.href);
        url.search = this.props.appSettingsModel.superpackageConflictConfirmRedirectUrlQueryString;

        window.location.href = url.toString();
    }

    _superPackageConflictRejectRedirect() {
        if (!this.props.appSettingsModel.superpackageConflictRejectRedirectUrlQueryString) return;

        this.props.dispatch(showLoadingScreen());
        const url = new URL(window.location.href);
        url.search = this.props.appSettingsModel.superpackageConflictRejectRedirectUrlQueryString;

        window.location.href = url.toString();
    }

    _flexPackageConflictConfirmRedirect() {
        if (!this.props.appSettingsModel.flexpackageConflictConfirmRedirectUrlQueryString) return;

        this.props.dispatch(showLoadingScreen());

        const url = new URL(window.location.href);
        url.search = this.props.appSettingsModel.flexpackageConflictConfirmRedirectUrlQueryString;

        window.location.href = url.toString();
    }

    _flexPackageConflictRejectRedirect() {
        const redirectQueryString = this.props.appSettingsModel.flexpackageConflictRejectRedirectUrlQueryString;

        this.props.dispatch(showLoadingScreen());

        if (!redirectQueryString) {
            window.location.href = '/';
            return;
        }

        window.location.href = redirectQueryString;
    }
}

export default connect((state) => state)(PackageQuantitySelect);